import { useMutation } from "@apollo/client";
import { useStore, useDispatch } from "react-redux";

import {
    SAVE_UPLOADS_FOR_LATER,
    REMOVE_UPLOADS_FROM_SAVED_FOR_LATER
} from "../mutations";

import * as Helpers from "../helpers";
import { uploadsSelectors } from "../selectors";

import { uploadStatusesChanged } from "../slices/uploadsSlice";

const useSaveUploadsForLater = () => {
    const store = useStore();
    const dispatch = useDispatch();

    const [saveUploadsForLater] = useMutation(SAVE_UPLOADS_FOR_LATER, {
        onCompleted: ({ save: { ok, individualResponses } }) => {
            if (!ok) return;

            dispatch(
                uploadStatusesChanged(
                    individualResponses.map(r => r.photoUpload)
                )
            );
        }
    });

    const [removeUploadsFromSavedForLater] = useMutation(
        REMOVE_UPLOADS_FROM_SAVED_FOR_LATER,
        {
            onCompleted: ({ resume: { ok, individualResponses } }) => {
                if (!ok) return;

                dispatch(
                    uploadStatusesChanged(
                        individualResponses.map(r => r.photoUpload)
                    )
                );
            }
        }
    );

    const saveUploads = async (uploadIds = []) => {
        if (!Array.isArray(uploadIds)) {
            return console.error(
                "Please pass array of upload IDs to saveUploads"
            );
        }

        if (!uploadIds.length) return;

        const result = await saveUploadsForLater({
            variables: {
                photoUploadIds: uploadIds
            }
        });

        return result.data.save;
    };

    const unsaveUploads = async (uploadIds = []) => {
        if (!Array.isArray(uploadIds)) {
            return console.error(
                "Please pass array of upload IDs to unsaveUploads"
            );
        }

        if (!uploadIds.length) return;

        const result = await removeUploadsFromSavedForLater({
            variables: {
                photoUploadIds: uploadIds
            }
        });

        return result.data.resume;
    };

    const handleSaveForLaterToggle = async (uploadIds = []) => {
        if (!uploadIds.length) return;

        const firstUploadId = uploadIds[0];

        const uploadsAreCurrentlySaved = Helpers.uploadIsSavedForLater(
            uploadsSelectors.selectById(store.getState(), firstUploadId)
        );

        if (!uploadsAreCurrentlySaved) {
            saveUploads(uploadIds);
        } else {
            unsaveUploads(uploadIds);
        }
    };

    return { saveUploads, unsaveUploads, handleSaveForLaterToggle };
};

export default useSaveUploadsForLater;
